import { useSearchParams } from 'react-router-dom';

/**
 * Custom hook to get the current locale from URL search params
 * Defaults to 'en' if no locale parameter is present
 */
export default function useLocale() {
  const [searchParams] = useSearchParams();
  return searchParams.get('locale') || 'en';
}
